<template>
	<div class="guess-like">
		<div class="title">
			<img class="title-img" src="/staticSeo/images/guessYouLike.png" alt="猜你喜欢" />
		</div>

		<NoImageBig
			:dataList="dataList"
			:showCart="false"
			:fromPage="fromPage"
			@click="handleClick"
			@addCartSuccess="handleAddCartSuccess"
		/>
	</div>
</template>

<script setup>
import NoImageBig from '@/components/NoImageBig.vue';

defineProps({
	dataList: {
		type: Array,
		default: () => [],
	},
	fromPage: {
		type: String,
		default: '猜你喜欢',
	},
});

const emit = defineEmits(['click', 'addCartSuccess']);

const handleClick = productInfo => {
	emit('click', productInfo);
};

const handleAddCartSuccess = payload => {
	emit('addCartSuccess', payload);
};
</script>

<style scoped lang="scss">
.guess-like {
	background: #f3f4f6;
	padding: 0;

	.title {
		width: 100%;
		height: 28px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 8px;

		.title-img {
			height: 100%;
			max-width: 100%;
		}
	}
}
</style>
